import { render, staticRenderFns } from "./CompetencyMatriz.vue?vue&type=template&id=e1653782&scoped=true"
import script from "./CompetencyMatriz.vue?vue&type=script&lang=js"
export * from "./CompetencyMatriz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1653782",
  null
  
)

export default component.exports